var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h2',[_vm._v("Ordenes de trabajo")]),_c('approval-orders-table',{attrs:{"loading":_vm.loading,"tasks":_vm.tasks,"orders":_vm.getOrders},on:{"updatePO":function($event){return _vm.updateTask($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }